<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" class="container mb-5">
  <div class="row mt-2">
    <div class="col-md-2">
      <button type="button" class="btn btn-secondary mr-3" data-dismiss="modal" aria-hidden="true" (click)="back()">&lt; Back</button>
    </div>
    <div class="col-md-8 text-center">
      <h3 *ngIf="conference" class="">Conference Registration</h3>
      <h3 *ngIf="!conference" class="">Bundle Registration</h3>
    </div>
    <div class="col-md-2"></div>
  </div>
  <div class="text-center"></div>
  <form #theForm="ngForm" novalidate>
    <div class="modal-body text-center">
      <div *ngIf="!auth.isLoggedIn()" class="">
        <h4>You not are logged in.</h4>
        <p>Please log in or create an account to register for this conference.</p>
        <button type="button" class="btn btn-primary" (click)="navigationService.showLogin()">Login/Sign-Up</button>
      </div>
    </div>
    <div *ngIf="auth.isLoggedIn()" class="modal-body">
      <div class="form-group text-center">
        <h6 class="text-center register-event-title">Package: {{ pckg.name }}</h6>
        <h6>
          <span *ngIf="pckg.ceuOverride && !pckg.noCEUs" class="btn btn-xs btn-soft-success btn-pill">{{ pckg.ceuOverride }} CEUs</span>
          <span *ngIf="!pckg.noCEUs && !pckg.ceuOverride">{{ pckg.totalCEUs | ceuDisplay }} </span>
<!--          <span *ngIf="pckg.noCEUs" class="btn btn-xs btn-soft-danger btn-pill">No CEUs</span>-->
        </h6>
        <h4>
          <span>{{ actualPrice | currency: pckg.currencyCode:'symbol' }}</span>
        </h4>
      </div>
      <div *ngIf="pckg.description" class="alert alert-warning" role="alert">
        {{ pckg.description }}
      </div>
      <div *ngIf="errorMessage" class="alert alert-primary" role="alert">
        {{ errorMessage }}
      </div>
      <div class="form-row">
        <div *ngIf="pckg.memberPricing && !conference.externalMemberLookup" class="col-md-6 mb-2">
          <label for="uname1"> Are you a member of {{ conference.organization.shortName }}?</label>
          <select class="form-control" (change)="calculatePrice()" required [(ngModel)]="isMember" name="isMemember">
            <option [ngValue]="null">Please choose....</option>
            <option [ngValue]="true">Yes ({{ pckg.price | currency: pckg.currencyCode:'symbol' }})</option>
            <option [ngValue]="false">No ({{ pckg.nonMemberPrice | currency: pckg.currencyCode:'symbol' }})</option>
          </select>
          <div class="invalid-message">
            <div>Please indicate your membership status</div>
          </div>
        </div>
        <div *ngIf="pckg.memberPricing && conference.externalMemberLookup" class="col-md-6 mb-4">
          <label *ngIf="!conference.onlyAllowMembersToRegister" class="d-block" for="uname1"> As a {{ conference.organization.shortName }} member, you are eligible for a discount. Click Below to look up your membership and apply the discount.</label>
          <label *ngIf="conference.onlyAllowMembersToRegister" class="d-block" for="uname1">
          <span *ngIf="conference.id != 380">  {{ conference.shortName }} only allows members to register for this conference. Click Below to look up your membership for confirmation.</span>
          <span *ngIf="conference.id == 380">  ABCABA25 only allows ABC Teammates to register for this conference. Click below to find your ABC email for confirmation.</span>
          </label>
          <button *ngIf="!membershipLookupResult" class="btn btn-admin-primary" type="button" (click)="checkMembership()">
            <span *ngIf="conference.id != 380">  Lookup Membership</span>
           <span *ngIf="conference.id == 380"> Lookup ABC Email</span>
          </button>
          <div *ngIf="membershipLookupResult" class="">
            <div class="input-group mb-3">
              <input class="form-control" readonly value="Linked Member: {{ membershipLookupResult.firstName }} {{ membershipLookupResult.lastName }}"/>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="membershipLookupResult = null; isMember = false; calculatePrice()" type="button" id="button-addon2">Unlink</button>
              </div>
              <div *ngIf="promoError" class="invalid-message-visible">
                <div>{{ promoError }}</div>
              </div>
            </div>
            <!-- <h5 class="">Linked Member: {{membershipLookupResult.firstName}} {{membershipLookupResult.lastName}} <a href="javascript:void()" (click)="">(Unlink)</a></h5> -->
          </div>
          <div class="invalid-message">
            <div>Please indicate your membership status</div>
          </div>
        </div>
        <ng-container *ngIf="!conference.onlyAllowMembersToRegister || (membershipLookupResult && membershipLookupResult.success)">
          <div *ngIf="pckg.ceUsAreExtra" class="col-md-6 mb-2">
            <label for="uname1"> Would you like to purchase CEUs?</label>
            <select class="form-control" (change)="calculatePrice()" required [(ngModel)]="purchaseCEUs" name="purchaseCEUs">
              <option [ngValue]="null">Please choose....</option>
              <option [ngValue]="true">Yes (+{{ (!pckg.memberPricing || isMember ? pckg.ceuPrice : pckg.ceuNonMemberPrice) | currency: pckg.currencyCode:'symbol' }})</option>
              <option [ngValue]="false">No</option>
            </select>
            <div class="invalid-message">
              <div>Please indicate if you want CEUs.</div>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="!conference.onlyAllowMembersToRegister || (membershipLookupResult && membershipLookupResult.success)">

        <div *ngIf="pckg.addOns.length > 0" class="form-row">
          <div class="col-md-12 mb-3">
            <div class="d-block">
              <strong>Add-ons (Optional):</strong>
            </div>

            <!-- Checkbox Switch -->
            <ng-container *ngFor="let addon of pckg.addOns; let i = index">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="addons{{ i }}" id="customSwitch{{ i }}"/>
                <label class="custom-control-label" for="customSwitch{{ i }}">
                <span class="d-block"
                >{{ addon.name }}
                  <span *ngIf="addon.price > 0">(+{{ addon.price | currency: pckg.currencyCode:'symbol' }})</span><span *ngIf="addon.price == 0">(FREE)</span></span
                >
                  <small class="d-block text-muted">{{ addon.description }}</small>
                </label>
              </div>
              <!-- End Checkbox Switch -->

              <hr class="my-2"/>
            </ng-container>
          </div>
        </div>
        <div *ngIf="pckg.eventAddons.length > 0" class="form-row">
          <div class="col-md-12 mb-3">
            <div class="d-block">
              <strong>Optional Events & Workshops:</strong>
            </div>
            <div *ngIf="conference.id == 225" class="alert alert-warning">
              Would you like to add any workshops?
              <button type="button" (click)="showWorkshops = !showWorkshops" class="btn d-block btn-xs btn-admin-primary">
                <span *ngIf="showWorkshops">Hide</span><span *ngIf="!showWorkshops">Show</span> Workshops
              </button>
            </div>
            <div *ngIf="pckg.eventAddonDiscountQuantityThreshold" class="alert alert-warning" role="alert">Purchase 2 or more workshops and receive a {{ pckg.eventAddonDiscountAmount | percent }} discount!</div>
            <!-- Checkbox Switch -->
            <ng-container *ngIf="showWorkshops || conference.id != 225">
              <ng-container *ngFor="let addon of pckg.eventAddons; let i = index">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="eventAddons{{ i }}" id="customEventSwitch{{ i }}"/>
                  <label class="custom-control-label" for="customEventSwitch{{ i }}">
                    <span *ngIf="addon.memberPricing && isMember" class="d-block"> {{ addon.title }} (+{{ addon.memberPrice | currency: pckg.currencyCode:'symbol' }})</span>
                    <span *ngIf="!addon.memberPricing || !isMember" class="d-block"> {{ addon.title }} (+{{ addon.price | currency: pckg.currencyCode:'symbol' }})</span>
                    <small class="d-block font-weight-semi-bold">{{ addon.formattedFullTime }}</small>
                    <small class="d-block text-muted">{{ addon.instructor.fullNameWithCredentials }}</small>
                  </label>
                  <a href="javascript:void(0);" (click)="showDetails(addon)" class="d-block">View Details</a>
                </div>
                <!-- End Checkbox Switch -->

                <hr class="my-2"/>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div *ngIf="startTimes.length > 0">
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <div class="d-block">
                <strong>Reserve Breakouts:</strong>
              </div>
              <div class="d-block">
                <small> Please select one breakout session at each time slot below for a total of six selections. Please note, there is a scroll on each session for a total of (14-16) choices at each time. All other conference sessions (with the exception of workshops) are pre-selected and included.</small>
              </div>
            </div>
          </div>
          <div class="form-row" *ngFor="let addon of startTimes; let i = index">
            <div class="col-md-12 mb-3">
              <!-- Checkbox Switch -->
              <div class="mb-2">
                <label for="uname1">{{ addon.key() }}</label>
                <event-picker class="form-control" required [data]="addon.getSource()" [valuePrimitive]="true" [(ngModel)]="reservedBreakouts[i]" name="reservedBreakout{{ i }}" textField="title" valueField="id"></event-picker>

                <!-- <select class="form-control" [(ngModel)]="tShirtSize" name="tShirtSize" required>
                <option *ngFor="let evt of addon.getSource()" value="{{ evt.id }}">{{ evt.title + ' (' + evt.totalCEUs + ' CEU)' }}</option>
              </select> -->
                <div class="invalid-message">
                  <div>This breakout is required</div>
                </div>
                <!-- End Checkbox Switch -->
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div *ngIf="conference" class="col-md-6 mb-2">
            <label for="uname1">Full Name & Credentials
              <i [pTooltip]="'This is the text that will show on your Badge by default.'" class="text-admin-primary fas fa-question-circle"></i></label>

            <input type="text" class="form-control" placeholder="Dr. Doogie Houser, MD" name="fullName" [(ngModel)]="fullName" required aria-label="fullName" aria-describedby="button-addon2"/>

            <div class="invalid-message">
              <div>Full Name is required</div>
            </div>
          </div>
          <div class="col-md-6 mb-2" *ngIf="conference && conference.id == 94">
            <label for="uname1">Pronouns (Public)</label>
            <input type="text" class="form-control" placeholder="She/Her, He/Him, They/Them" name="pronouns" [(ngModel)]="pronouns" aria-label="pronouns" aria-describedby="button-addon2"/>
          </div>

          <div class="col-md-6 mb-2" *ngIf="pckg.id == 1111">
            <label for="uname1">Search for a Roommate (First Choice)</label>
            <kendo-combobox required [filterable]="true" [popupSettings]="{ width: 400 }" (filterChange)="handleFilter($event)" [loading]="instructorLoading" class="form-control" [valuePrimitive]="true" [(ngModel)]="customField1" name="customField1" [data]="instructorData | async" textField="fullName" valueField="id">
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <div class="d-flex">
                  <img style="width: 30px; height: 30px" [fallback]="'fetch-avatar?userId=' + dataItem.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ dataItem.id }}-avatar.png"/>
                  <div class="ml-1 flex-grow">
                    <div class="d-block">{{ dataItem.lastName }} {{ dataItem.firstName }}</div>
                    <div class="d-block">{{ dataItem.email }}</div>
                  </div>
                </div>
              </ng-template>
            </kendo-combobox>
            <div class="invalid-message">
              <div>Please choose a roommate</div>
            </div>
          </div>
          <div class="col-md-6 mb-2" *ngIf="pckg.id == 1111">
            <label for="uname1">Search for a Roommate (Second Choice) </label>
            <kendo-combobox required [filterable]="true" [popupSettings]="{ width: 400 }" (filterChange)="handleFilter($event)" [loading]="instructorLoading" class="form-control" [valuePrimitive]="true" [(ngModel)]="customField2" name="customField2" [data]="instructorData | async" textField="fullName" valueField="id">
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <div class="d-flex">
                  <img style="width: 30px; height: 30px" [fallback]="'fetch-avatar?userId=' + dataItem.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ dataItem.id }}-avatar.png"/>
                  <div class="ml-1 flex-grow">
                    <div class="d-block">{{ dataItem.lastName }} {{ dataItem.firstName }}</div>
                    <div class="d-block">{{ dataItem.email }}</div>
                  </div>
                </div>
              </ng-template>
            </kendo-combobox>
            <div class="invalid-message">
              <div>Please choose a roommate</div>
            </div>
          </div>
          <div class="col-md-6 mb-2" *ngIf="pckg.id == 1111">
            <label for="uname1">Search for a Roommate (Third Choice)</label>
            <kendo-combobox required [filterable]="true" [popupSettings]="{ width: 400 }" (filterChange)="handleFilter($event)" [loading]="instructorLoading" class="form-control" [valuePrimitive]="true" [(ngModel)]="customField3" name="customField3" [data]="instructorData | async" textField="fullName" valueField="id">
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <div class="d-flex">
                  <img style="width: 30px; height: 30px" [fallback]="'fetch-avatar?userId=' + dataItem.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ dataItem.id }}-avatar.png"/>
                  <div class="ml-1 flex-grow">
                    <div class="d-block">{{ dataItem.lastName }} {{ dataItem.firstName }}</div>
                    <div class="d-block">{{ dataItem.email }}</div>
                  </div>
                </div>
              </ng-template>
            </kendo-combobox>
            <div class="invalid-message">
              <div>Please choose a roommate</div>
            </div>
          </div>
          <div *ngIf="conference" class="col-md-6 mb-2">
            <label for="uname1">Company / Organization</label>

            <input type="text" class="form-control" placeholder="ACME Inc" name="affiliation" required [(ngModel)]="affiliation" aria-label="Affiliation" aria-describedby="button-addon2"/>

            <div class="invalid-message">
              <div>Company / Affiliation is required</div>
            </div>
          </div>
          <div *ngIf="pckg.customQuestionSurveyId" class="col-md-12">
            <survey class="survey-embed" [model]="surveyModel"></survey>
          </div>
          <div *ngFor="let field of pckg.customRegistrationFields; let idx = index" class="col-md-6 mb-2">
            <label for="uname1">{{ field.questionText }}</label>

            <input *ngIf="field.fieldType.toString() == RegistrationFieldType[RegistrationFieldType.Text]" type="text" class="form-control" [(ngModel)]="field.responseText" placeholder="{{ field.placeholderText }}" [required]="field.required" name="customField+{{ idx }}" aria-describedby="button-addon2"/>
            <select *ngIf="field.fieldType.toString() == RegistrationFieldType[RegistrationFieldType.SingleSelect]" class="form-control" (change)="calculatePrice()" [required]="field.required" [(ngModel)]="field.responseOption" name="customField+{{ idx }}">
              <option [ngValue]="null">Please choose....</option>
              <option *ngFor="let option of field.options" [ngValue]="option.id">{{ option.optionText }}</option>
            </select>
            <div class="invalid-message">
              <div>This field is required</div>
            </div>
          </div>
        </div>
        <hr class="my-2"/>

        <div class="form-row">
          <div class="col-md-6" *ngIf="pckg.price > 0">
            <label for="uname1">Promo Code</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Promo Code" name="promoCode" [(ngModel)]="promoCode" aria-label="Promo Code" aria-describedby="button-addon2"/>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="applyPromoCode()" type="button" id="button-addon2">Apply</button>
              </div>
              <div *ngIf="promoError" class="invalid-message-visible">
                <div>{{ promoError }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="actualPrice > 0">
          <div class="col-md-6 mb-2">
            <label for="uname1">Card Number</label>
            <input type="text" class="form-control" [(ngModel)]="cardNumber" name="cardNumber" required creditcard placeholder="Card Number"/>
            <div class="invalid-message">
              <div>Card Number is required</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-xs-4 mb-2">
            <label for="uname1">Month</label>
            <select class="form-control" [(ngModel)]="expMo" name="expMo" required>
              <option value="1">01 - January</option>
              <option value="2">02 - February</option>
              <option value="3">03 - March</option>
              <option value="4">04 - April</option>
              <option value="5">05 - May</option>
              <option value="6">06 - June</option>
              <option value="7">07 - July</option>
              <option value="8">08 - August</option>
              <option value="9">09 - September</option>
              <option value="10">10 - October</option>
              <option value="11">11 - November</option>
              <option value="12">12 - December</option>
            </select>
            <div class="invalid-message">
              <div>Month is required</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-xs-4 mb-2">
            <label for="uname1">Year</label>
            <select class="form-control" [(ngModel)]="expYr" name="expYr" required>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
              <option value="2031">2031</option>
              <option value="2032">2032</option>
              <option value="2033">2033</option>
              <option value="2034">2034</option>
            </select>
            <div class="invalid-message">
              <div>Year is required</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-xs-4 mb-2">
            <label for="uname1">CVV</label>
            <input type="text" class="form-control" [(ngModel)]="cvv" name="cvv" placeholder="CVV" required/>
            <div class="invalid-message">
              <div>CVV is required</div>
            </div>
          </div>
        </div>

        <div *ngIf="errorMessage" class="alert alert-primary mt-2" role="alert">
          {{ errorMessage }}
        </div>
        <div class="form-group text-center mt-3">
          <button type="button" class="btn btn-primary" data-dismiss="modal" aria-hidden="true" [promiseBtn]="submitComplete" (click)="purchasePackageClicked()">Complete Registration - {{ actualPrice | currency: pckg.currencyCode:'symbol' }}</button>
        </div>
      </ng-container>
    </div>
  </form>
</div>
